import React from 'react'

import { KeyAccessType, KeyType } from '@/types/Key'

export const HomeKeySummary = ({
  accessType,
  count,
  keyType,
  onChangeHomeKeyGroup,
}: {
  accessType: KeyAccessType
  count: number
  keyType: KeyType
  onChangeHomeKeyGroup: (accessType: KeyAccessType, keyType: KeyType) => void
}) => {
  return (
    <div className="items-center flex rounded-xl px-4 py-3 bg-action-secondary">
      <button
        className="cursor-pointer w-full text-p-sm text-semantic-success hover:underline"
        onClick={() => onChangeHomeKeyGroup(accessType, keyType)}
      >
        <div className="flex items-center justify-center">
          <p className="font-medium text-p-md">{count}</p>
        </div>
        <div className="flex items-center justify-center">
          <p className="font-bold text-p-md">
            {accessType} {keyType}s
          </p>
        </div>
      </button>
    </div>
  )
}
